module.exports = __webpack_public_path__ + "img/2.75f4a4b.png";